module.exports = __webpack_public_path__ + "img/Geometric1.9e1ded2b.jpg";